import axios from "../utils/Net";


export const $getSysBySysNo=async (params)=>{
    let {data}=await axios.postForm('/api/sys/get-sysNo',params);
    return data;
}

export const $getSysByHost=async (params)=>{
    let {data}=await axios.postForm('/api/sys/get-host',params);
    return data;
}


